import {
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatLegacyAutocomplete as MatAutocomplete, MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { UrlService } from '@service/url/url.service';
import { CarrierLanesTable, IS_NOT_EMPTY, RestService } from 'cargo-chief-commons';
import { DESTINATION_TYPES } from '@domain/constants/app-variables';

@Component({
	selector: 'app-destinations',
	templateUrl: './destinations.component.html',
	styleUrls: ['./destinations.component.scss'],
})
export class DestinationsComponent implements OnInit {
	@Input() lane: CarrierLanesTable;
	@Input() inputConfig: any = {
		origin: false,
		trailerType: false,
		destination: false,
	};

	destination;

	regionsList = [];
	selectedDestinations = [];
	filteredDestinations: Observable<any[]>;

	model = {
		destCity: '',
		destState: '',
		destCountry: '',
		destZip: '',
		destLat: '',
		destLng: '',
		destinationStates: '',
	};

	separatorKeysCodes: number[] = [ENTER, COMMA];
	@ViewChild('destinationRegion') regionInput: ElementRef<HTMLInputElement>;
	@ViewChild('auto') matAutocomplete: MatAutocomplete;
	destinationListCtrl = new UntypedFormControl();

	@Output() destinationChanges = new EventEmitter<any>();

	DESTINATION_TYPES = DESTINATION_TYPES;
	currentDestinationType: string = null;

	constructor(
		private urlService: UrlService,
		private restService: RestService,
		private utilService: UtilService,
		private changeDetector: ChangeDetectorRef
	) {}

	ngOnInit() {
		this.getRegionList();
		if (!this.utilService.isNullOrUndefined(this.lane)) {
			if (!this.utilService.isNullOrUndefined(this.lane.destination)) {
				this.destination = this.lane.destination || '';
				if (!this.utilService.isNullOrUndefined(this.lane.destination)) {
					this.model.destCity = this.lane.destination.split(', ')[0] || '';
					this.model.destState = this.lane.destination.split(', ')[1] || '';
					this.model.destCountry = this.lane.destinationMetadata?.country || '';
				}
			}
			if (
				!this.utilService.isNullOrUndefined(this.lane.destinationStates) &&
				this.lane.destinationStates.length > 0
			) {
				this.selectedDestinations = [...this.lane.destinationStates];
			}
		}
	}

	initializeDestinationType() {
		if (this.selectedDestinations.length > 0) {
			if (!this.utilService.isNullOrUndefined(this.regionsList) && this.regionsList.length > 0) {
				let isRegionMatched: boolean = false;
				this.regionsList.map((region) => {
					if (
						JSON.parse(region.stateList).states.sort().join(',') ==
						this.selectedDestinations.sort().join(',')
					) {
						isRegionMatched = true;
					}
				});
				if (isRegionMatched) {
					this.currentDestinationType = DESTINATION_TYPES.REGION;
				} else {
					this.currentDestinationType = DESTINATION_TYPES.STATES;
				}
			} else {
			}
		} else {
			this.currentDestinationType = DESTINATION_TYPES.CITY;
		}
	}

	getRegionList() {
		const url = this.urlService.getRegionMap();
		this.restService.GET(url).subscribe(
			(response) => {
				this.regionsList = response;
				this.filteredDestinations = this.destinationListCtrl.valueChanges.pipe(
					startWith(null),
					map((state: string | null) => (state ? this._filter(state) : this.regionsList.slice()))
				);
				this.initializeDestinationType();
			},
			(error) => {
				this.utilService.showSnackbar(
					'Unable to fetch maps region.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
				this.initializeDestinationType();
			}
		);
	}

	selected(event: MatAutocompleteSelectedEvent): void {
		if (
			!this.utilService.isNullOrUndefined(event) &&
			!this.utilService.isNullOrUndefined(event.option) &&
			!this.utilService.isNullOrUndefined(event.option.viewValue)
		) {
			const selectedRegionName = event.option.viewValue;
			this.regionsList.map((region) => {
				if (selectedRegionName === region.regionName) {
					this.selectedDestinations = this.selectedDestinations
						.concat(JSON.parse(region.stateList).states || [])
						.filter((elem, index, self) => {
							return index === self.indexOf(elem);
						});
				}
			});
			this.emitDestinations();
		}
	}

	remove(index: number): void {
		if (index >= 0 && index < this.selectedDestinations.length) {
			this.selectedDestinations.splice(index, 1);
			this.emitDestinations();
		}
	}

	detect() {
		this.changeDetector.detectChanges();
		if (!this.utilService.isNullOrUndefined(this.regionInput)) {
			setTimeout(() => {
				if (!this.utilService.isNullOrUndefined(this.regionInput.nativeElement)) {
					this.regionInput.nativeElement.focus();
				}
			});
		}
		this.selectedDestinations = [];
		this.model.destCity = '';
		this.model.destState = '';
		this.model.destCountry = '';
		this.model.destinationStates = '';
		this.emitDestinations();
	}

	addState(state: any) {
		if (state.value.length == 2) {
			this.selectedDestinations.push(state.value);
			this.selectedDestinations.filter((elem, index, self) => {
				return index === self.indexOf(elem);
			});
			this.emitDestinations();
		}
	}

	getAddressOnChange($event, LocationCtrl) {
		if (LocationCtrl != 'origin') {
			this.model.destCity = $event.city;
			this.model.destState = $event.state;
			this.model.destCountry = $event.country;
			this.model.destLat = $event.latitude;
			this.model.destLng = $event.longitude;
			this.model.destZip = $event.zip;
			this.emitDestinations();
		}
	}

	emitDestinations() {
		this.model.destinationStates = this.selectedDestinations.join(',');
		this.destinationChanges.emit(this.model);
	}

	private _filter(value: string): string[] {
		const filterValue = IS_NOT_EMPTY(value) ? value.toLowerCase() : '';
		const regions = this.regionsList.filter((region) => {
			return region['regionName'];
		});
		return regions.filter((region: any) => {
			if (!this.utilService.isNullOrUndefined(region) && IS_NOT_EMPTY(region.regionName)) {
				return region.regionName.toLowerCase().indexOf(filterValue) > -1;
			}
		});
	}
}
